export default __webpack_public_path__ + "static/media/constructionok.447bcc11.png";